import React from "react";
import PropTypes from "prop-types";

import "./SchoolLogo.css";

export default class SchoolLogo extends React.Component {

  static propTypes = {
    logoURL: PropTypes.string,
    schoolName: PropTypes.string.isRequired,
    cssBlockName: PropTypes.string,
    cssModifier: PropTypes.string
  }

  state = {
    hasImageLoadFailed: false
  }

  render() {

    const { schoolName, logoURL, cssBlockName, cssModifier } = this.props;
    const classNames = [ "school-logo" ];
    if (cssBlockName) {
      classNames.push(`${cssBlockName}__school-logo`);
    }
    if (cssModifier) {
      classNames.push(`school-logo--${cssModifier}`);
    }

    return (
      <div className={classNames.join(" ")}>
        <img className="school-logo__img" src={logoURL} alt={schoolName} />
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./src/components/SchoolLogo.js